import { AdminSubscriptionListAction } from '../enums/admin-subscription-list-action';

export class AdminSubscriptionAfterActionExecuteEvent {
  public constructor(
    private readonly data: {
      action: AdminSubscriptionListAction;
    },
  ) {}

  public get action(): AdminSubscriptionListAction {
    return this.data.action;
  }
}
